import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import PropTypes from 'prop-types';
import App from './App.jsx';
import RouteErrorBoundary from './components/RouteErrorBoundary.jsx';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './index.css';
import store from './store';
import { Provider } from 'react-redux';
import HomeScreen from './screens/HomeScreen';
import LoginScreen from './screens/LoginScreen.jsx';
import ForgotPasswordScreen from './screens/ForgotPasswordScreen.jsx';
import RegisterScreen from './screens/RegisterScreen.jsx';
import ProfileScreen from './screens/ProfileScreen.jsx';
import ResetPasswordScreen from './screens/ResetPasswordScreen.jsx';
import PrivateRoute from './components/PrivateRoute.jsx';
import LeaguesScreen from './screens/LeaguesScreen.jsx';
import LeagueManageScreen from './screens/LeagueManageScreen.jsx';
import TeamScreen from './screens/TeamScreen.jsx';
import AthleteScreen from './screens/AthleteScreen.jsx';
import EventScreen from './screens/EventScreen.jsx';
import ActivitiesScreen from './screens/Activities.jsx';
import StravaScreen from './screens/StravaScreen.jsx'
import AdminScreen from './screens/AdminScreen.jsx';
import AdminErrorLogsScreen from './screens/AdminErrorLogsScreen.jsx';
import GarminAdminDiagnostics from './screens/GarminAdminDiagnostics.jsx';
import TestAdminScreen from './screens/TestAdminScreen.jsx';
import PlayerAssignmentScreen from './screens/PlayerAssignmentScreen.jsx';
import DemoScreen from './screens/DemoScreen.jsx';
import PrivacyScreen from './screens/PrivacyScreen.jsx';
import TermsScreen from './screens/TermsScreen.jsx';
import InvitationScreen from './screens/InvitationScreen.jsx';
import AboutScreen from './screens/AboutScreen.jsx';
import ContactScreen from './screens/ContactScreen.jsx';
import GetStartedScreen from './screens/GetStartedScreen.jsx';
import TestingScreen from './screens/TestingScreen.jsx';
import NewsListScreen from './screens/NewsListScreen.jsx';
import NewsPostScreen from './screens/NewsPostScreen.jsx';
import AdminNewsScreen from './screens/AdminNewsScreen.jsx';
import LeagueManagerSlideshowScreen from './screens/LeagueManagerSlideshowScreen.jsx';

const DraftScreen = lazy(() => import('./screens/DraftScreen.jsx'));
const DraftTestScreen = lazy(() => import('./screens/DraftTestScreen.jsx'));

const LazyRoute = ({ children }) => (
  <Suspense
    fallback={(
      <div className="container py-5 text-center">
        Loading...
      </div>
    )}
  >
    {children}
  </Suspense>
);

LazyRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />} errorElement={<RouteErrorBoundary />}>
      <Route index={true} path='/' element={<HomeScreen />} />
      <Route path='/login' element={<LoginScreen />} />
      <Route path='/forgot-password' element={<ForgotPasswordScreen />} />
      <Route path='/register' element={<RegisterScreen />} />
      <Route path='/reset-password/:token' element={<ResetPasswordScreen />} />
      <Route path='/privacy' element={<PrivacyScreen />} />
      <Route path='/terms' element={<TermsScreen />} />
  <Route path='/demo' element={<DemoScreen />} />
  <Route path='/about' element={<AboutScreen />} />
  <Route path='/contact' element={<ContactScreen />} />
        <Route path='/get-started' element={<GetStartedScreen />} />
      <Route path='/news' element={<NewsListScreen />} />
      <Route path='/news/:slug' element={<NewsPostScreen />} />
      <Route path='/league-manager-slideshow' element={<LeagueManagerSlideshowScreen />} />
      <Route path='/invite/:inviteId' element={<InvitationScreen />} />
      
      <Route path='' element={<PrivateRoute />}>
        <Route path='/profile' element={<ProfileScreen />} />
        <Route path='/leagues' element={<LeaguesScreen />} />
        <Route path='/leagues/:id' element={<LeaguesScreen />} />
        <Route path='/leagues/:id/manage' element={<LeagueManageScreen />} />
        <Route path='/team' element={<TeamScreen />} />
        <Route path='/team/:id' element={<TeamScreen />} />
        <Route path='/dashboard' element={<AthleteScreen />} />
        <Route path='/athlete-select' element={<Navigate to='/dashboard' replace />} />
        <Route path='/athlete' element={<AthleteScreen />} />
        <Route path='/athlete-enhanced' element={<Navigate to='/dashboard' replace />} />
        <Route path='/athlete-complete' element={<Navigate to='/dashboard' replace />} />
          <Route path='/event' element={<EventScreen />} />
          <Route path='/activities' element={<ActivitiesScreen />} />
          <Route path='/strava' element={<StravaScreen />} />
        <Route path='/draft/:draftId' element={<LazyRoute><DraftScreen /></LazyRoute>} />
        <Route path='/draft-test' element={<LazyRoute><DraftTestScreen /></LazyRoute>} />
  <Route path='/admin' element={<AdminScreen />} />
  <Route path='/admin/news' element={<AdminNewsScreen />} />
  <Route path='/admin/errors' element={<AdminErrorLogsScreen />} />
  <Route path='/admin/garmin' element={<GarminAdminDiagnostics />} />
        <Route path='/admin/assignments/:leagueId' element={<PlayerAssignmentScreen />} />
        <Route path='/test-admin' element={<TestAdminScreen />} />
        <Route path='/testing' element={<TestingScreen />} />
      </Route>
    </Route>
  )
);

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </Provider>
);
